import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { EVENTS } from "./events";
import { track } from "./client";
import { pageViewKey, pageViewProperties } from "./routes";

// sends page_viewed once per real navigation
// - `authReady` holds it back until the user is identified and routes are
//   mounted, so events carry the right traits and auth redirects aren't counted
export const usePageTracking = authReady => {
  const history = useHistory();
  const location = useLocation();
  const lastPageKey = useRef(null);
  const lastModalKey = useRef(null);

  useEffect(() => {
    if (!authReady) return undefined;

    const timer = setTimeout(() => {
      const current = history.location;

      const isModal = !!current.state?.background;
      const lastKey = isModal ? lastModalKey : lastPageKey;
      if (!isModal) lastModalKey.current = null;

      const key = pageViewKey(current);
      if (key === null || key === lastKey.current) return;

      lastKey.current = key;
      track(EVENTS.page_viewed, pageViewProperties(current));
    }, 0);

    return () => clearTimeout(timer);
  }, [history, location, authReady]);
};
